import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Badge, Button, Col, Row } from 'reactstrap';
import { withRouter } from 'react-router';

import NavigationTree from '../../navigation/NavigationTree';
import Paths from '../../../types/Paths';
import globalTranslations from '../../../i18n/globalTranslations';
import RouteService from '../../../services/RouteService';
import UIStore from '../../../store/UIStore';
import { modelOf } from '../../../prop-types';
import Icon from '../../common/Icon';
import CollapseMenu from '../../common/CollapseMenu';
import TopLevelNavigationDropdown from '../../common/TopLevelNavigationDropdown';
import ConfigStore from '../../../store/ConfigStore';

@observer
export class MyAccountNavigation extends Component {
  state = {
    collapse: false
  };

  convertPathsToNavigationEntities = () => {
    const { orderCount, routes, routeService, userCount } = this.props;

    const labels = {
      [Paths.MyAccount]: <FormattedMessage {...globalTranslations.myAccount} />,
      [Paths.MyAccountBalanceUser]: (
        <FormattedMessage {...globalTranslations.myAccount} />
      ),
      [Paths.MyAccountBalanceSubUser]: (
        <FormattedMessage {...globalTranslations.myAccount} />
      ),
      [Paths.MyAccountInfo]: (
        <FormattedMessage {...globalTranslations.myAccountInfo} />
      ),
      [Paths.MyAccountBalanceUserAccountInfo]: (
        <FormattedMessage {...globalTranslations.balanceUserAccountInfo} />
      ),
      [Paths.MyAccountOrderList]: (
        <Fragment>
          <FormattedMessage {...globalTranslations.myOrderHistoryTitle} />
          {orderCount ? (
            <Badge
              pill
              key={Paths.MyAccountOrderList + orderCount}
              className="MyAccountNavigation__menu-badge"
            >
              {orderCount}
            </Badge>
          ) : null}
        </Fragment>
      ),
      [Paths.MyAccountChangePassword]: (
        <FormattedMessage {...globalTranslations.myAccountChangePassword} />
      ),
      [Paths.MyAccountAddressList]: (
        <FormattedMessage {...globalTranslations.addressBookTitle} />
      ),
      [Paths.MyAccountUserList]: (
        <Fragment>
          <FormattedMessage {...globalTranslations.userListTitle} />
          {userCount ? (
            <Badge
              pill
              key={Paths.MyAccountUserList + userCount}
              className="MyAccountNavigation__menu-badge"
            >
              {userCount}
            </Badge>
          ) : null}
        </Fragment>
      ),
      [Paths.MyAccountPurchasesList]: (
        <FormattedMessage {...globalTranslations.purchasesListTitle} />
      ),
      [Paths.MyAccountCreditAccount]: (
        <FormattedMessage {...globalTranslations.creditAccountTitle} />
      ),
      [Paths.MyAccountBalanceUserPaymentHistory]: (
        <FormattedMessage
          {...globalTranslations.balanceUserAccountBalanceInfo}
        />
      ),
      [Paths.CustomerProducts]: (
        <FormattedMessage {...globalTranslations.customerProductsTitle} />
      ),
      [Paths.MyAccountPaymentTokenList]: (
        <FormattedMessage {...globalTranslations.paymentTokensTitle} />
      ),
      [Paths.MyAccountRecurringOrderList]: (
        <FormattedMessage {...globalTranslations.recurringOrdersTitle} />
      )
    };

    return routes.filter((route) => !!labels[route.path]).map((route) => {
      return {
        id: route.path,
        label: labels[route.path],
        path: routeService.getPath(route.path)
      };
    });
  };

  toggle = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  render() {
    const { uiStore, configStore } = this.props;
    const navigation = (
      <NavigationTree items={this.convertPathsToNavigationEntities()} />
    );

    if (uiStore.isMobile) {
      return (
        <Row className="MyAccountNavigation">
          <Col
            className="MyAccountNavigation__toggle-col"
            xs="12"
            onClick={this.toggle}
          >
            <Button>
              <Icon name="bars" className="fa-2x" />
            </Button>
          </Col>
          <Col className="MyAccountNavigation__sidebar" xs="12">
            <CollapseMenu collapse={this.state.collapse}>
              {navigation}
            </CollapseMenu>
          </Col>
        </Row>
      );
    }
    return (
      <div className="MyAccountNavigation">
        {uiStore.isDesktop &&
          configStore.mainNavigation.useSidebar && (
            <TopLevelNavigationDropdown />
          )}
        <div className="MyAccountNavigation__sidebar">{navigation}</div>
      </div>
    );
  }
}

MyAccountNavigation.propTypes = {
  uiStore: modelOf(UIStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  orderCount: PropTypes.number,
  userCount: PropTypes.number
};

export default inject('routeService', 'uiStore', 'configStore')(
  withRouter(MyAccountNavigation)
);



// WEBPACK FOOTER //
// ./src/components/my-account/MyAccountNavigation/index.jsx